/**
 * Icon List.
 *
 * @format
 */

export const iconList = [
  'advanced-care',
  'benefits',
  'calendar',
  'chat',
  'contact',
  'design',
  'employees',
  'fragmented-workflows',
  'funding-research',
  'gears',
  'hq-care',
  'human-centered',
  'infinity',
  'ingenuity',
  'inspiring',
  'interoperability',
  'intuitive-operation',
  'investor',
  'key-partnerships',
  'locations',
  'lock',
  'meaningful-innovation',
  'operational-excellence',
  'occlusion',
  'patients',
  'predictable-outcomes',
  'purpose-1',
  'purpose-2',
  'reduce-costs',
  'remove-obstacles',
  'strong-roi',
  'structural-resiliency',
  'support-network',
  'targeting',
  'time-back',
];

export const safeColors = (color: string) => {
  const safeColorList = [
    'blue',
    'black',
    'white',
    'gray-dark',
    'gray-medium',
    'gray-blue',
  ];
  if (safeColorList.includes(color)) {
    return color;
  }
  return 'blue';
};
